/**
 * Copyright Warner Bros. Entertainment, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property
 * of Warner Bros. Entertainment, Inc. and its suppliers, if any.
 * The intellectual and technical concepts contained herein are
 * proprietary to Warner Bros. Entertainment, Inc. and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in process,
 * and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is
 * unlawful and strictly forbidden unless prior written permission is
 * obtained from Warner Bros. Entertainment, Inc.
 */

import PropTypes from 'prop-types';
import React, {Component} from 'react';
import ReactSelect from 'react-select';

import {DeliveryConstants} from './delivery-actions';
import {MessagesContext} from '../../../messages/messages-context';

class MetadataExportSpec extends Component {
    static get propTypes() {
        return {
            disabled: PropTypes.bool,
            onChange: PropTypes.func.isRequired,
            value: PropTypes.number,
        };
    }

    static get defaultProps() {
        return {
            disabled: true,
            value: undefined,
        };
    }

    constructor(props) {
        super(props);
        this.handleMetadataExportSpecChange = this.handleMetadataExportSpecChange.bind(this);
        return;
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.disabled !== this.props.disabled ||
            nextProps.value !== this.props.value) {
            return true;
        }
        return false;
    }

    static contextType = MessagesContext;

    handleMetadataExportSpecChange(value) {
        this.props.onChange(value);
    }

    render() {
        let selectedExport = DeliveryConstants.EXPORT_SPECIFICATIONS.find((item) => item.id === this.props.value) || null;
        return (
            <ReactSelect
                getOptionLabel={data => data.name}
                getOptionValue={data => data.id}
                isClearable={true}
                isMulti={false}
                isDisabled={this.props.disabled}
                name="exportSpecification"
                onChange={this.handleMetadataExportSpecChange}
                options={DeliveryConstants.EXPORT_SPECIFICATIONS}
                value={selectedExport}
            />
        );
    }
}

export default MetadataExportSpec;
